import { render, staticRenderFns } from "./questionBankList.vue?vue&type=template&id=72755234&scoped=true&"
import script from "./questionBankList.vue?vue&type=script&lang=js&"
export * from "./questionBankList.vue?vue&type=script&lang=js&"
import style0 from "./questionBankList.vue?vue&type=style&index=0&id=72755234&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72755234",
  null
  
)

export default component.exports